/**
 * Holds the bearer session token of native clients. Memory only: it is never written to
 * storage, so a reload or restart ends the session together with the vault keys.
 */
export class TokenHolder {
  private token: string | undefined;

  public get(): string | undefined {
    return this.token;
  }

  public set(token: string): void {
    this.token = token === "" ? undefined : token;
  }

  public clear(): void {
    this.token = undefined;
  }
}

export const bearerToken = new TokenHolder();
